import { useEffect, useState, useContext } from 'react'
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { Form, Select, DatePicker, Row, Col, TreeSelect, Input, Button, Space } from 'antd'

const { RangePicker } = DatePicker
import arrToListOption from '@/utils/arrToListOption'
import { SDrawer } from 'shj-components'

const Option = Select.Option
import dayjs from 'dayjs'
import { findSeatByDeptCode, findSeatDeptCode } from '@/services/callCenter'
import {filterSearchData2} from "@/utils/common.ts";
import {departmentTree} from "@/services/content.ts";
import {getUser} from "@/common/utils.ts";
import {getUserIdentityFn} from "@/pages/clueManage/utils.tsx";

export default function AdvancedFilter(props: any) {
  const userInfo = getUser()
  const { updateCallManageState, callManageState } = useContext(callContext)
  const { callFormData, advancedFormData, refreshList, callAllState = {} } = callManageState || {}
  const {
    clueStateList,
    visible,
    onCancel,
    bizOpPropertyTypeList,
    sourceChannelList,
    onOk,
    quickTime,
    cityArea,
  } = props
  const [form] = Form.useForm()
  const [companyList, setCompanyList] = useState<any[]>([]) // 派单公司
  const [deptCodeList, setDeptCodeList] = useState<any[]>([]) // 坐席部门列表
  const [seatsList, setSeatsList] = useState<any[]>([]) // 坐席人员列表
  const [dispatchStatusVisible, setDispatchStatusVisible] = useState<boolean>(false) // 派单状态显示
  const dispatchStatus: any = [
    // 派单状态列表
    { text: 'CLUE', title: '线索' },
    { text: 'SALE_MAN_PENDING', title: '营销待定' },
    { text: 'ORDINARY_MSG', title: '有效线索' },
    { text: 'VALID_MSG', title: '意向线索' },
    { text: 'DESIGN', title: '已转设计' },
    { text: 'INVALID', title: '无效' },
  ]
  const tabValue = { 全部: false, 派单: false, 信息: true, 待定: true, 公海: true }
  // 坐席部门列表
  // const deptCodeList = [{ text: '101152716', title: '云客服中心' }]

  useEffect(() => {
    form.setFieldsValue({ ...advancedFormData })
  }, [advancedFormData])
  useEffect(() => {
    if (props.companyList) fetchCompanyList()
  }, [props.companyList])
  useEffect(() => {
    fetchSeatDeptList();
  }, [])
  const fetchCompanyList = () => {
    const list: any[] = []
    props.companyList.map((res: any) => {
      list.push({
        label: res.name,
        value: res.id,
      })
    })
    setCompanyList([...list])
  }

  // 获取坐席部门列表
  const fetchSeatDeptList = () => {
    departmentTree(userInfo.companyId, {
      "direction": "DOWN"
    }).then(res => {
      console.log(res, 'dept')
      setDeptCodeList([...res])
    })
  }

  // 获取坐席人员列表
  const fetchSeatsList = (deptCode: any) => {
    getUserIdentityFn(['ykf', 'ykfjl'], {orgId: deptCode}).then((res: any) => {
      const list = res || []
      form.setFieldsValue({ workNumberList: [] })
      setSeatsList([...list])
    })
  }

  // 递归查找
  const findChild = (list: any[]) => {
    let _arr: any[] = []
    list.map((item: any) => {
      if (item.children && item.children.length) {
        _arr = [..._arr, ...findChild(item.children)]
      } else {
        _arr.push(item.id)
      }
    })
    return _arr
  }
  // 表单更新时
  const onValuesChange = (changedValues: any, allValues: any) => {
    // 如果变动是线索状态则清除派单状态选择
    if (
      changedValues.hasOwnProperty('status') &&
      changedValues.status &&
      changedValues.status != 'CLUE,SALE_MAN_PENDING,ORDINARY_MSG,VALID_MSG,DESIGN,INVALID'
    ) {
      form.setFieldsValue({ dispatchStatus: [] })
    }
    // 派单状态是否显示
    if (
      allValues.status &&
      allValues.status != 'ALL' &&
      allValues.status != 'CLUE,SALE_MAN_PENDING,ORDINARY_MSG,VALID_MSG,DESIGN,INVALID'
    ) {
      setDispatchStatusVisible(true)
    } else if (dispatchStatusVisible) {
      setDispatchStatusVisible(false)
    }
    // 坐席部门更新时,获取坐席列表
    if (changedValues.deptCode) {
      fetchSeatsList(changedValues.deptCode)
    } else if (changedValues.hasOwnProperty('deptCode')) {
      form.setFieldsValue({ workNumberList: [] })
      setSeatsList([])
    }
  }
  const onSubmit = () => {
    const params = form.getFieldsValue()

    updateCallManageState({
      callFormData: { ...callFormData, ...params },
      refreshList: !refreshList,
    })
    onCancel()
    onOk({ ...callFormData, ...params })
  }
  const onReset = () => {
    form.resetFields()
  }
  return (
    <SDrawer
      title="高级筛选"
      open={visible}
      onClose={onCancel}
      onResetFn={onReset}
      onSubmit={onSubmit}
      {...props}
      className="sdrawer"
      footer={
        <div style={{ width: '100%', display: 'flex', justifyContent: "space-between" }}>
          <Button onClick={onReset}>
            重置
          </Button>
          <Space>
            <Button onClick={onCancel}>
              取消
            </Button>
            <Button type="primary" onClick={onSubmit}>
              保存
            </Button>
          </Space>
        </div>

      }
    >
      <Form layout={'vertical'} form={form} onValuesChange={onValuesChange} initialValues={advancedFormData}>
        <Row gutter={10}>
          {(callAllState.tabValue == '全部' || callAllState.tabValue == '公海') && <Col span={12}>
            <Form.Item label="线索状态" name="status">
              <Select
                  placeholder="请选择"
                  disabled={callAllState.tabValue != '全部' && callAllState.tabValue != '公海'}
                  showSearch
                  optionFilterProp='children'
              >
                {arrToListOption(clueStateList, {value: 'value', title: 'label'})}
              </Select>
            </Form.Item>
          </Col>}
          <Col span={12}>
            <Form.Item label="派单状态" name="dispatchStatus">
              <Select
                placeholder="请选择"
                mode="multiple"
                disabled={tabValue[callAllState.tabValue] || dispatchStatusVisible}
                showSearch
                optionFilterProp='children'
              >
                {arrToListOption(dispatchStatus)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="房屋属性" name="houseNatureCode">
              <Select placeholder="请选择" allowClear showSearch optionFilterProp='children'>
                {arrToListOption(bizOpPropertyTypeList, { value: 'key', title: 'description' })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="派单公司" name="orgId">
              <Select placeholder="请选择" allowClear showSearch optionFilterProp='children'>
                {arrToListOption(companyList, { value: 'value', title: 'label' })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12} style={{ whiteSpace: 'nowrap' }}>
            <Form.Item name="channelIds" hidden={true}>
              <Input />
            </Form.Item>
            <Form.Item label="客户来源" name="client_source">
              <TreeSelect
                placeholder="请选择"
                allowClear
                showSearch
                filterTreeNode={(inputValue: any, treeNode: any) => {
                  return treeNode.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                }}
                onClear={() => {
                  form.setFieldsValue({ channelIds: '' })
                }}
                treeData={sourceChannelList}
                onSelect={(a: any, b: any) => {
                  let ids = []
                  if (b.children && b.children.length) {
                    ids = findChild(b.children)
                  } else {
                    ids = [b.id]
                  }
                  form.setFieldsValue({ channelIds: ids })
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="报名时间" name="signTime">
              <RangePicker
                  style={{width: '100%'}}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="派单时间" name="dispatchTime">
              <RangePicker
                  style={{width: '100%'}}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="跟进时间" name="lastFollowTime">
              <RangePicker
                  style={{width: '100%'}}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="通话时间" name="lastCallTime">
              <RangePicker
                  style={{width: '100%'}}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="坐席部门" name="deptCode">
              <TreeSelect placeholder="请选择" treeData={deptCodeList} allowClear showSearch fieldNames={{value: 'id'}} treeNodeFilterProp={'label'}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="坐席人员" name="workNumberList">
              <Select
                placeholder="请选择" mode="multiple"
                allowClear 
                showSearch
                filterOption={(input: string, option) => {
                  return (option?.children ?? '')?.toLowerCase().includes(input.toLowerCase());
                }}
                notFoundContent='请选择坐席部门或暂无数据'
                optionFilterProp='children'
              >
                {arrToListOption(seatsList, { value: 'ucenterUserId', title: 'userName' })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="派单快捷" name="dispatchDateRange">
              <Select placeholder="请选择" allowClear>
                {quickTime.map((res: any) => {
                  return (
                    <Option key={res.key} value={res.key}>
                      {res.desc}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="是否已回单" name="isReturn">
              <Select placeholder="请选择" allowClear>
                <Option value={1}>是</Option>
                <Option value={0}>否</Option>
              </Select>
            </Form.Item>
          </Col>
          {/*<Col span={12}>
            <Form.Item label="是否已签单" name="isSign">
              <Select placeholder="请选择" allowClear>
                <Option value={1}>是</Option>
                <Option value={0}>否</Option>
              </Select>
            </Form.Item>
          </Col>*/}
          <Col span={12}>
            <Form.Item label="报名城市" name="cityAreaCode">
              <Select placeholder="请选择" allowClear showSearch optionFilterProp='children'>
                {arrToListOption(cityArea, { value: 'cityCode', title: 'regionName' })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SDrawer >
  )
}
